import {StorageUtils} from 'xmgoing-utils';

export function useIsOperateHook(){

  const isOerateUser=ref(false);

  if(StorageUtils.getSessionItem("loginUserType")==='operateUser'){
    isOerateUser.value=true;
  }

  return {
    isOerateUser
  }
}
